import { IItemIdName, IItemKeyCaregiver } from "./common";

export enum ClientStateType {
  Basic = "basic",
  New = "new",
  Active = "active",
  InActive = "inActive",
  Rejected = "rejected",
  Dead = "dead",
  Anonymised = "anonymised",
}

export enum ClientIdentityType {
  IdentityCard = "identityCard",
  Passport = "passport",
  Unverified = "unverified",
  ResidencePermit = "residencePermit",
}

export enum ClientMaritalStatusType {
  Single = "single",
  Married = "married",
  Divorced = "divorced",
  Widow = "widow",
  RegisteredPartnership = "registeredPartnership",
}

export enum ClientHouseLivingType {
  Standard = "standard",
  PsychiatricHospital = "psychiatricHospital",
  OtherMedicalFacalities = "OtherMedicalFacilities",
  ZUVVTOS = "ZUVVTOS",
  SpecialPurposeApartment = "specialPurposeApartment",
  NonresidentalSpace = "nonresidentalSpace",
  ProtectedHousing = "protectedHousing",
  Azyl = "azyl",
  HalWayHouse = "halWayHouse",
  Dorm = "dorm",
  Homeless = "homeless",
  Hostel = "hostel",
  CompanyApartmentMCP7 = "companyApartmentMCP7",
  UniversityDormitory = "universityDormitory",
  SeniorCareHome = "seniorCareHome",
}

export enum ClientHouseOwnershipType {
  Personal = "personal",
  Rent = "rent",
  RentalAgreementTermInfinite = "rentalAgreementTermInfinite",
  RentalAgreementTermFinite = "rentalAgreementTermFinite",
  CooperativeApartment = "cooperativeApartment",
  RentOffice = "rentOffice",
  LivingWithRelatives = "livingWithRelatives",
  LivingWithPartner = "livingWithPartner",
  LivingWithAcquaintances = "livingWithAcquaintances",
  AccommodationAgreement = "accommodationAgreement",
}

export enum ClientRevenueType {
  InvalidityPension = "invalidityPension",
  Salary = "salary",
  Pension = "pension",
  TemporaryJob = "temporaryJob",
  UnemploymentCompensation = "unemploymentCompensation",
  Alimony = "alimony",
  FinancialHelpInMaternity = "financialHelpInMaternity",
  WidowsPension = "widowsPension",
  OrphansPension = "orphansPension",
  Other = "other",
}

export enum ClientDebtType {
  Loan = "loan",
  Credit = "credit",
  Execution = "execution",
  Insolvency = "insolvency",
  Receivable = "receivable",
}

export enum ClientCareStateType {
  Preparation = "preparation",
  InProgress = "inProgress",
  Postponed = "postponed",
  PrematurelyFinished = "prematurelyFinished",
  Finished = "finished",
}

export interface IClientItem {
  id: number;
  state: ClientStateType;
  title?: string | null;
  firstName: string;
  lastName: string;
  degree?: string | null;
}

export interface IClient {
  id: number;
  state: ClientStateType;
  login?: string | null;
  firstName: string;
  lastName: string;
  maidenName?: string | null;
  title?: string | null;
  degree?: string | null;
  mobilePhone?: string | null;
  email?: string | null;
  phone?: string | null;
  dataBox?: string | null;
  identityType?: ClientIdentityType | null;
  identityCode?: string | null;
  birthDate?: Date | null;
  identificationNumber?: string | null;
  maritalStatus?: ClientMaritalStatusType | null;

  fullRegistration: boolean;

  addressPermanentStreet?: string | null;
  addressPermanentHouseNumber?: string | null;
  addressPermanentLandRegistryNumber?: string | null;
  addressPermanentCity?: string | null;
  addressPermanentPostCode?: number | null;

  addressActualStreet?: string | null;
  addressActualHouseNumber?: string | null;
  addressActualLandRegistryNumber?: string | null;
  addressActualCity?: string | null;
  addressActualPostCode?: number | null;

  addressMailStreet?: string | null;
  addressMailHouseNumber?: string | null;
  addressMailLandRegistryNumber?: string | null;
  addressMailCity?: string | null;
  addressMailPostCode?: number | null;

  addressActualIsSame: boolean;
  addressMailIsSame: boolean;

  keyCaregiver?: IItemKeyCaregiver | null;
  healthInsurance?: IItemIdName | null;
  gdprAgreementAt?: Date | null;
  gdprAgreementAddedByUser?: IItemIdName | null;
  gdprAgreementWithoutSecret?: boolean | null;
}

export interface IClientHouse {
  livingType?: ClientHouseLivingType | null | "";
  ownershipType?: ClientHouseOwnershipType | null | "";
  floorNumber?: number | null;
  conditions?: string | null;
  barriers?: string | null;
  personsInHousehold?: number | null;
  permanentResidenceSinceYear?: number | null;
  costPerMonth?: number | null;
  termination?: boolean | null;
}

export interface IClientRiskGrid {
  items: IItemIdName[];
}

export interface IClientRevenueItem {
  id: number;
  type: ClientRevenueType;
  amountPerMonth: number;
  description?: string | null;
}

export interface IClientBenefitItem {
  id: number;
  typeId: number;
  typeName: string;
  amountPerMonth: number;
  description?: string | null;
}

export interface IClientDebtItem {
  id: number;
  type: ClientDebtType;
  amount: number;
  amountPerMonth: number;
  description?: string | null;
}

export interface IClientNoteItem {
  id: number;
  informationType: IItemIdName;
  legacyTitle?: string | null;
  description: string;
  createdAt: Date;
  creator?: IItemIdName | null;
  canEdit: boolean;
  canDelete: boolean;
}

export interface IClientNoteWrite {
  informationTypeId: number;
  description: string;
}

export interface IClientCareItem {
  id: number;
  assistanceAddress: IItemIdName;
  careType: IItemIdName;
  from: Date;
  to?: Date | null;
  state: ClientCareStateType;
}

export interface IClientCare {
  id: number;
  client: IItemIdName;
  assistance: IItemIdName;
  assistanceAddress: IItemIdName;
  assistanceCategoryListing: IItemIdName;
  careType: IItemIdName;
  from: Date;
  to?: Date | null;
  state: ClientCareStateType;
  note?: string | null;
}

export enum SignedEnum {
  signed = "signed",
  notSigned = "unsigned",
  pending = "pending",
}
export interface IClientDocumentItem {
  id: number;
  name: string;
  author: IItemIdName;
  createdAt: Date;
  lastEditedAt: Date;
  lastEditor: IItemIdName;
  state: SignedEnum;
  isClientVisible: boolean;
  archivedAt?: string | null;
  isArchived: boolean;
  assistances?: IItemIdName[];
  roles?: IItemIdName[];
  groups?: IItemIdName[];
  users?: IItemIdName[];
  cachedFolder?: { name: string; id: number } | null;
}

export interface IClientContactPersonItem {
  id: number;
  name: string;
  type: IItemIdName;
  mobilePhone?: string | null;
  phone?: string | null;
  email?: string | null;
}

export interface IClientContactPerson {
  id: number;
  isActive: boolean;
  login?: string | null;
  type: IItemIdName;
  firstName: string;
  lastName: string;
  title?: string | null;
  degree?: string | null;
  mobilePhone?: string | null;
  email?: string | null;
  phone?: string | null;
}
